import { render, staticRenderFns } from "./ConcorrenteCadastro.vue?vue&type=template&id=5859b7d2&scoped=true&lang=html&"
import script from "./ConcorrenteCadastro.vue?vue&type=script&lang=js&"
export * from "./ConcorrenteCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ConcorrenteCadastro.vue?vue&type=style&index=0&id=5859b7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859b7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
